module.exports = __webpack_public_path__ + "static/Pt04-77cf352018917a13d30a3f9d9c0f65f5.jpg";